import React, { useCallback } from 'react';
import { Button } from 'js/components/common/Button';
import { useTranslations } from 'js/hooks/i18n';
import { withComponent } from 'js/components/hocs/withComponent';
import { componentService } from 'js/services/component.service';
import { showConfirmationPopupAction } from '../../common/popups/ConfirmationPopup/actions';
import { useDispatch } from 'react-redux';

export const GamblingSuspensionSwissBare: React.FC = () => {
    const translate = useTranslations();
    const dispatch = useDispatch();

    const showPopup = useCallback((): void => {
        dispatch(showConfirmationPopupAction({
            isModal: false,
            isGamblingSuspension: true,
            title: translate('playtech.mobile.system.gamblingSuspension.title')
        }));
    }, [dispatch, translate]);

    return (
        <Button onClick={showPopup}>
            {translate('playtech.mobile.system.button.gamblingSuspension')}
        </Button>
    );
};

export const GamblingSuspensionSwiss = withComponent({
    isForLoggedIn: true
})(GamblingSuspensionSwissBare);

// <hub2-gambling-suspension-swiss></hub2-gambling-suspension-swiss>
componentService.registerWebContentComponents({ GamblingSuspensionSwiss });

